import { useTranslation } from "react-i18next";

import { Group } from "#shared/view/components/Group";
import { Modal } from "#shared/view/components/Modal";
import { Text } from "#shared/view/components/Text";
import { Button } from "#shared/view/designSystem/Button";
import { Checkbox } from "#shared/view/designSystem/Checkbox";

type MaterialChangeDisclaimerModalProps = {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  checkboxProps: {
    id: string;
    checked: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  };
};

export const MaterialChangeDisclaimerModal = ({
  opened,
  onClose,
  onConfirm,
  checkboxProps,
}: MaterialChangeDisclaimerModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal opened={opened} onClose={onClose} title={t("qrl.materialChangeWarning.title")} centered>
      <Text mb="md">{t("qrl.materialChangeWarning.message")}</Text>
      <Group align="center" mb="md">
        <Checkbox {...checkboxProps} label={t("qrl.materialChangeWarning.dontShowAgain")} />
      </Group>
      <Group justify="flex-end" mt="md" gap="xs">
        <Button variant="outline" onClick={onClose}>
          {t("common.cancel")}
        </Button>
        <Button onClick={onConfirm}>{t("qrl.materialChangeWarning.modify")}</Button>
      </Group>
    </Modal>
  );
};
